/** 培训教育业务阶段：A 编制中 / B 待开场 / C 进行中 / D 考核中 / E 已办结 */

export function trainingPhaseOf(form) {
  const row = form || {}
  const people = Array.isArray(row.shouldArrivePeople) ? row.shouldArrivePeople : []
  const signed =
    people.some((item) => item && item.isCheckedIn === '已签到') ||
    Number(row.signedCount != null ? row.signedCount : row.isDone) > 0
  const answered =
    people.some(
      (item) => item && item.assessmentScore != null && item.assessmentScore !== ''
    ) || Number(row.answerCount || 0) > 0
  const videos = row.trainingVideos
  const hasVideo = Array.isArray(videos) ? videos.length > 0 : !!videos
  const timeReached =
    !!row.trainingTime && !isNaN(new Date(row.trainingTime).getTime())
      ? new Date(row.trainingTime).getTime() <= Date.now()
      : false
  if (hasVideo) return 'E'
  if (answered) return 'D'
  if (signed || timeReached) return 'C'
  if (row.uid) return 'B'
  return 'A'
}

export function canRemoveTrainingLinked(phase, kind) {
  if (kind === 'material') return phase === 'A' || phase === 'B'
  if (kind === 'paper') return phase === 'A' || phase === 'B' || phase === 'C'
  if (kind === 'person') return phase === 'A' || phase === 'B' || phase === 'C' || phase === 'D'
  return false
}

export function canAddTrainingLinked(phase, kind) {
  if (kind === 'material') return phase === 'A' || phase === 'B' || phase === 'C'
  if (kind === 'paper') return phase === 'A' || phase === 'B' || phase === 'C'
  if (kind === 'person') return phase === 'A' || phase === 'B' || phase === 'C' || phase === 'D'
  return false
}

export function isTrainingFieldLocked(phase, key) {
  if (phase === 'A' || phase === 'B') return false
  const core = {
    trainingType: true,
    trainingNo: true,
    trainingName: true,
    trainingTime: true,
    trainingMethods: true,
    examineType: true,
    answerRule: true
  }
  if (phase === 'C') return !!core[key]
  if (phase === 'D') return key !== 'trainingVideos' && key !== 'trainingPics'
  return true
}

/**
 * 列表按钮：查看 0、编辑 1、删除 2、执行 3、二维码 4
 */
export function trainingListDisabledButtons(item, opts) {
  const disabled = []
  const otherOrg = !!(opts && opts.otherOrg)
  const superAdmin = !!(opts && opts.superAdmin)
  if (otherOrg) return ['', 1, 2, 3, '']
  const phase = trainingPhaseOf(item)
  if (phase === 'E') disabled.push(1)
  if (phase === 'C' || phase === 'D' || phase === 'E') {
    if (!superAdmin) disabled.push(2)
  }
  return disabled
}
